/**
 * レイヤーのモーダル (MotionLayerModal) を開く要求 (motion-graphics-mode-plan.md §5.2)。
 * 開く導線が 2 つあり (設定欄の「レイヤーを確認・編集」と選択済み素材チップの「N レイヤー」バッジ)、
 * チップ (GenerationWorkspace 配下) と設定欄 (PromptModePanel) は親子関係に無いため、対象の素材 id だけを
 * ここで共有する。モーダル本体は PromptModePanel が motion 中だけ描く。名前・固定の編集は layerEditsStore。
 */
import { create } from 'zustand';

type LayerModalState = {
  /** 開いているモーダルの素材 id。null = 閉じている */
  openMaterialId: string | null;
  openLayerModal: (materialId: string) => void;
  closeLayerModal: () => void;
};

export const useMotionLayerModalStore = create<LayerModalState>((set) => ({
  openMaterialId: null,
  openLayerModal: (materialId) => set({ openMaterialId: materialId }),
  closeLayerModal: () => set({ openMaterialId: null }),
}));
